import { Target, Eye, Gem } from "lucide-react"; // Install lucide-react if not already

export default function Values() {
  const items = [
    {
      title: " Mission",
      icon: <Target className="h-10 w-10 text-emerald-600 mb-4" />,
      description:
        "To provide innovative and reliable engineering design services that empower businesses in the automotive and electrical sectors.",
    },
    {
      title: "Vision",
      icon: <Eye className="h-10 w-10 text-emerald-600 mb-4" />,
      description:
        "To be the preferred global partner in engineering design outsourcing by consistently exceeding client expectations.",
    },
    {
      title: "Our Values",
      icon: <Gem className="h-10 w-10 text-emerald-600 mb-4" />,
      description:
        "We believe in integrity, innovation and delivering impact through excellence in engineering solutions.",
    },
  ];

  return (
    <div className="mt-16 max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10 pb-20">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-gray-50 border border-emerald-100 rounded-2xl p-8 text-center shadow-md hover:shadow-lg transition-transform hover:-translate-y-1 duration-300"
        >
          <div className="flex justify-center">{item.icon}</div>
          <h3 className="text-2xl font-bold mb-3 text-emerald-700">{item.title}</h3>
          <p className="text-gray-700 text-sm leading-relaxed">{item.description}</p>
        </div>
      ))}
    </div>
  );
}
